import { useEffect } from "react";
import { usePartnerInfo } from "../usePartnerInfoContext";
import { logger } from "src/Utils/LoggerService/LoggerService";
import { InfoMessageType } from "src/SharedComponents/InfoBar/InfoBar";
import { useGetTutorialVideos } from "./useGetTutorialVideos";

export const useGetTutorialVideosWrapper = () => {
    const {data, loading, error } = useGetTutorialVideos()
    const { setInfobar, setLoader, reset } = usePartnerInfo();
    useEffect(() => {
        if (error) {
            logger.logError(`Failed to fetch tutorial videos.`)
            setInfobar({message: error, messageType: InfoMessageType.error});
        }
    }, [error, setInfobar])

    useEffect(()=> {
        setLoader(loading);
    }, [loading, setLoader])
    useEffect(() => {
        reset();
    },[reset])
    return {data}
}